import {IActionModel} from "../../shared/models/action.model";
import {SET_TABLE_COLUMN_DATA} from "../actions/table.action";

export interface ITableReducerState {
    columnData: any[];
}

const INITIAL_STATE: ITableReducerState = {
    columnData: []
};

const tableReducer = (state: ITableReducerState = INITIAL_STATE, action: IActionModel): ITableReducerState => {
    switch (action.type) {
        case SET_TABLE_COLUMN_DATA:
            return {
                ...state,
                columnData: action.payload,
            };
        default:
            return state;
    }
};

export default tableReducer;